import React from "react";
import { Modal } from "../../BP2Components";
import FormComplete from "../../FormsV2/FormComplete";
import PropTypes from "prop-types";
import "./ActionsModal.less";

const ActionsModal = ({ modalData, handleClose, saveCallback }) => {
   return (
      <Modal isOpen={modalData.isOpen} onCancel={handleClose} width={1100} height={800}>
         <section className="actions-modal">
            {modalData.isOpen && (
               <FormComplete
                  formId={modalData?.formId}
                  actionId={modalData.actionId}
                  recordId={modalData.recordId}
                  formKey={modalData.formKey}
                  label={modalData?.label}
                  printable
                  saveCallback={() => {
                     saveCallback && saveCallback();
                     handleClose();
                  }}
                  hideAttachments={true}
               />
            )}
         </section>
      </Modal>
   );
};

ActionsModal.propTypes = {
   modalData: PropTypes.objectOf({
      isOpen: PropTypes.bool,
      actionId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      recordId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
   }),
   handleClose: PropTypes.func,
};

export default ActionsModal;
